import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMinetestComponent } from './simple-icons-minetest.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMinetestComponent ],
    exports:      [ SimpleIconsMinetestComponent ],
    bootstrap:    []
})
export class SimpleIconsMinetestModule {}
